import axios from "axios";
import Config from "../../config";
import { getToken } from "../service";
import PlvVideoUpload from "@polyv/vod-upload-js-sdk";

export interface Next {
    total: {
        loaded: number;
        percent: number;
        size: number;
    };
}
export interface Complete {
    hash: string;
    key: string;
}

/**
 * 获取七牛云上传token
 */

/**
 * 获取七牛云上传token
 */
export function getQiniuUploadTokenSource(
    cancelToken?: any,
    url: string = "/teacher/getUpTokenKczyOpen"
) {
    return axios.post(url, {}, { cancelToken }).then(res => res.data);
}

export interface onUploadProgressProps {
    percent: number;
    file: File;
    index: number;
}
export interface onUploadOkProps {
    res: { hash: string; key: string };
    file: File;
    index: number;
}
export interface onUploadErrorProps {
    e: ErrorEvent;
    file: File;
    index: number;
}
export interface UploadParams {
    onUploadProgress: (data: onUploadProgressProps) => void;
    onOk: (data: onUploadOkProps) => void;
    onError: (data: onUploadErrorProps) => void;
    index: number;
}

/**
 * 上传到七牛
 */
export async function uploadToQiNiuGen(
    file: File,
    options: UploadParams,
    cancelToken: any,
    tokenUrl?: string
) {
    const request = axios.create();
    const token = await getQiniuUploadTokenSource(cancelToken, tokenUrl);
    const formData = new FormData();

    formData.append("file", file);
    formData.append("token", token.message);

    function onUploadProgress(progressEvent: any) {
        options?.onUploadProgress({
            file,
            index: options.index,
            percent: (progressEvent.loaded * 100) / progressEvent.total
        });
    }

    return request
        .post<{ hash: string; key: string }>(Config.QiNiuUploadUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress,
            cancelToken
        })
        .then(res =>
            options.onOk({
                file,
                index: options.index,
                res: res.data
            })
        )
        .catch(e => {
            options.onError({ e, file, index: options.index });
        });
}

/**
 * 返回polyv密钥
 */
function getPolyvKey() {
    const token = getToken();
    const headers = { token };

    return axios
        .get<SuccessData<{ sign: string; ptime: string; hash: string }>>(
            "/teacher/polyv/getPolyvKey",
            { headers }
        )
        .then(res => res.data.data);
}

/**
 * 更新保利威上传标识
 * @param videoUpload
 */
async function updatePolyUserData(videoUpload: any) {
    const userid = Config.PolyUid;
    const { ptime, sign, hash } = await getPolyvKey();

    return videoUpload.updateUserData({
        userid, // Polyv云点播账号的ID
        ptime, // 时间戳
        sign, // 是根据将secretkey和ts按照顺序拼凑起来的字符串进行MD5计算得到的值
        hash // 是根据将ts和writeToken按照顺序拼凑起来的字符串进行MD5计算得到的值
    });
}

/**
 * 上传到保利威
 */
export async function uploadToPolyVLast(file: File, options?: UploadParams) {
    const videoUpload = new PlvVideoUpload();

    await updatePolyUserData(videoUpload);
    const interval = setInterval(updatePolyUserData, 1000 * 60 * 2);

    const fileSetting = {
        // 文件上传相关信息设置
        title: file.name // 标题
    };

    return new Promise<string>((resolve, reject) => {
        videoUpload.addFile(
            file,
            {
                FileProgress: function (uploadInfo: any) {
                    options?.onUploadProgress({
                        file,
                        index: options.index,
                        percent: uploadInfo.progress * 100
                    });
                },
                FileSucceed: function (uploadInfo: any) {
                    resolve(uploadInfo.fileData);
                    options?.onOk({
                        file,
                        index: options.index,
                        res: {
                            hash: uploadInfo.fileData.vid,
                            key: uploadInfo.fileData.vid || ""
                        }
                    });
                    clearInterval(interval);
                },
                FileFailed: function (uploadInfo: any) {
                    reject(uploadInfo.errData);
                    options?.onError({
                        e: uploadInfo.errData,
                        file,
                        index: options.index
                    });
                    clearInterval(interval);
                }
            },
            fileSetting
        );

        videoUpload.startAll();
    });
}
